import { observer } from 'mobx-react';
import * as React from 'react';
import { handleEnterKeyPress, handleEscKeyDown } from '../../../../../Accessibility/KeyboardEvents';
import ClickOutsideStore from '../../../../../ClickOutsideStore';
import { useOpenable } from '../../../../Modal/UseOpenable';
import ActionItemsPopover from './ActionItemsPopover';
import { when } from '@execonline-inc/maybe-adapter';

interface Props {
  icon: React.JSX.Element;
  content: React.JSX.Element;
}

const ActionItems: React.FC<Props> = ({ icon, content }) => {
  const actionItemsRef = React.useRef<HTMLDivElement>(null);
  const { modalState, open, close } = useOpenable();

  const toggle = () => {
    switch (modalState.kind) {
      case 'open':
        close();
        break;
      case 'closed':
        ClickOutsideStore.addListener({ ref: actionItemsRef, callback: close });
        open();
    }
  };

  const handleKeyPress = (
    e: React.KeyboardEvent<HTMLDivElement>,
    toggle: () => void,
    close: () => void,
  ) => {
    when(e.key === 'Enter', e)
      .do(handleEnterKeyPress(toggle))
      .elseDo(() => handleEscKeyDown(close));
  };

  return (
    <div
      onClick={toggle}
      ref={actionItemsRef}
      data-test-actionitems={true}
      id="popover-container"
      tabIndex={-1}
    >
      <div
        data-test-dropdown-header={icon}
        tabIndex={0}
        onKeyDown={(e) => handleKeyPress(e, toggle, close)}
        className="cursor-pointer relative"
      >
        {icon}
      </div>
      <ActionItemsPopover content={content} modalState={modalState} />
    </div>
  );
};

export default observer(ActionItems);
